import { baseRoutes } from "helpers/baseRoutes";

/**
 * Define access routes for authentication, specifying paths using baseRoutes from the "helpers/baseRoutes" module.
 * Each route has a unique identifier and a corresponding path.
 * @constant {Object} accessRoute
 */
const accessRoute = {
  LOGIN: {
    path: `${baseRoutes.instructorBaseRoutes}`,
  },
  SIGN_UP: {
    path: `${baseRoutes.instructorBaseRoutes}/sign-up`,
  },
  FORGOT_PASSWORD: {
    path: `${baseRoutes.instructorBaseRoutes}/forgot-password`,
  },
  RESET_PASSWORD: {
    path: "/reset-password/:token",
  },
  OTP_VERIFICATION: {
    path: `${baseRoutes.instructorBaseRoutes}/otp-verification`,
  },
  CHANGE_PASSWORD: {
    path: `${baseRoutes.instructorBaseRoutes}/change-password`,
  },
};

export default accessRoute;
